<template>
  <div class="drawer left-side"
  ref="drawer"
  @mousedown.prevent.stop="onMousedown"
  :style="{
    left: position.left,
    width: width,
    'padding-right': (padding+'px'),
    'margin-right': (-padding+'px')
  }"
  :class="{
    isClosed: isClosed,
    isOpened: !isClosed,
    isMobile: isMobile,
    'transition-generic': !isMoving
  }">
    <div
      class="drawer-opener touch-only mobile-only fixed-left"
    ></div>
    <div
      ref="backdrop"
      @click="backdropClick"
      class="drawer-backdrop fullscreen"
    ></div>
    <div
      :style="{
        right: (padding+'px')
      }"
      ref="content"
      class="drawer-content left-side"
    >
      <slot></slot>
    </div>
  </div>
</template>
<script>
var rAF = window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.oRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  function (callback) { window.setTimeout(callback, 1000 / 60) }

export default {
  data () {
    return {
      width: '280px',
      position: {
        top: '0px',
        left: '0px'
      },
      isMoving: false,
      isClosed: false,
      isMobile: false,
      padding: 10
    }
  },
  mounted: function () {
    var slider = this.$refs.drawer
    var rect = slider.getBoundingClientRect()
    // this.dimension = rect
    this.dimension = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.width,
      x: rect.x,
      y: rect.y
    }

    var deviceWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width

    if (parseInt(deviceWidth) <= 567) {
      this.isMobile = true
      this.isClosed = true
    }

    // this.isMobile = true

    // console.log(this.dimension.width)
    if (this.isClosed) {
      // this.position.left = (-this.dimension.width) + 'px'
      // this.width = (this.dimension.width + this.padding) + 'px'
      this.close()
    }
  },
  methods: {
    bind: function () {
      window.addEventListener('touchend', this.onEnd)
      window.addEventListener('touchcancel', this.onEnd)
      window.addEventListener('touchleave', this.onEnd)
      window.addEventListener('mouseup', this.onEnd)

      window.addEventListener('touchmove', this.onMove)
      window.addEventListener('mousemove', this.onMove)
    },
    unbind: function () {
      window.removeEventListener('touchend', this.onEnd)
      window.removeEventListener('touchcancel', this.onEnd)
      window.removeEventListener('touchleave', this.onEnd)
      window.removeEventListener('mouseup', this.onEnd)

      window.removeEventListener('touchmove', this.onMove)
      window.removeEventListener('mousemove', this.onMove)
    },
    onMousedown: function (e) {
      this.currentPosition = this.initialPosition = this.getEventPosition(e)
      this.tmpPosition = {
        top: this.initialPosition.top,
        left: this.initialPosition.left
      }

      this.isMoving = true
      this.bind()
      this.anim()
    },
    onEnd: function (e) {
      this.unbind()
      this.isMoving = false
      var distance_left = this.initialPosition.left - this.currentPosition.left

      // console.log(Math.abs(distance_left))

      if (distance_left > this.dimension.width / 5) {
        this.close()
      }
      else {
        this.open()
      }
    },
    onMove: function (e) {
      this.currentPosition = this.getEventPosition(e)
    },
    getEventPosition: function (e) {
      let posx, posy
      e = e || window.event

      if (e.touches && e.touches[0]) {
        e = e.touches[0]
      }
      else if (e.changedTouches && e.changedTouches[0]) {
        e = e.changedTouches[0]
      }

      if (e.clientX || e.clientY) {
        posx = e.clientX
        posy = e.clientY
      }
      else if (e.pageX || e.pageY) {
        posx = e.pageX - document.body.scrollLeft - document.documentElement.scrollLeft
        posy = e.pageY - document.body.scrollTop - document.documentElement.scrollTop
      }

      return {
        top: posy,
        left: posx
      }
    },
    anim: function () {
      if (this.isMoving) {
        if (this.tmpPosition.left !== this.currentPosition.left) {
          var decal_left = this.currentPosition.left - this.initialPosition.left

          if (this.isClosed && decal_left > 0) {
            if (decal_left > this.dimension.width) {
              decal_left = this.dimension.width
            }
            // this.position.left = (decal_left - this.dimension.width) + 'px'
            this.width = decal_left + 'px'
          }
          else if (!this.isClosed && decal_left < 0) {
            // this.position.left = decal_left + 'px'
            this.width = (this.dimension.width + decal_left) + 'px'
          }
          this.tmpPosition.left = this.currentPosition.left
        }

        rAF(this.anim)
      }
    },
    toggle: function () {
      this.isClosed = !this.isClosed
      this.isMoving = false

      if (this.isClosed) {
        // this.position.left = (-this.dimension.width) + 'px'
        this.width = '0px'
      }
      else {
        // this.position.left = '0px'
        this.width = this.dimension.width + 'px'
      }
    },
    open: function () {
      this.isClosed = false
      this.isMoving = false
      // this.position.left = '0px'
      this.width = this.dimension.width + 'px'
    },
    close: function () {
      this.isClosed = true
      this.isMoving = false
      // this.position.left = (-this.dimension.width) + 'px'
      this.width = '0px'
    },
    backdropClick: function () {
      this.close()
    }
  }
}
</script>

<style>

.drawer {
  z-index: 140;
  position: absolute;
  overflow: visible;
  -webkit-overflow-scrolling: touch;
  will-change: scroll-position;
  width: 280px;
  left: 0;
  top: 0;
  bottom: 0;
  transform: translateZ(0px);
  -webkit-text-size-adjust: none;
  max-width: 280px;

  position: relative;
  flex-shrink: 1;
  
}
.drawer-content {
  z-index: 30;
  position: absolute;
  background: #fff;
  right: 0;
  top: 0;
  bottom: 0;
  width: 280px;
  font-size: 1rem;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  will-change: scroll-position, transform;
  transition: all .2s ease-in-out;
  box-shadow: 0 5px 5px -3px rgba(0,0,0,.2),
  0 8px 10px 1px rgba(0,0,0,.14),
  0 3px 14px 2px rgba(0,0,0,.12);
}

.drawer.isMobile {
  position: absolute;
}
/*
.drawer-inner {
  height: 100%;
  width: 100%;
  box-shadow: 0 5px 5px -3px rgba(0,0,0,.2),
  0 8px 10px 1px rgba(0,0,0,.14),
  0 3px 14px 2px rgba(0,0,0,.12);
  position: relative;
}*/

.transition-generic {
  transition: all .3s;
}
/*
.drawer {
  z-index: 111;
}
*/
.drawer-backdrop {
  display: none;
  z-index: 30;
  background: rgba(0, 0, 0, 0.7);
}

.isOpen .drawer-backdrop {
  display: block;
  z-index: 30;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.drawer-opener {
  z-index: 11;
  height: 100vh;
  /*width: 15px;*/
  width: 0;
  opacity: 0;
}
/*
.drawer.active .drawer-content {
  left: 0;
}
.drawer-content.left-side {
  left: -282px;
}
.drawer-content.right-side {
  right: 0;
  left: 280px;
}
body.cordova.platform-ios .drawer-content {
  padding-top: 20px;
}

.drawer.active .drawer-opener {
  display: none;
}
@media screen and (min-width: 921px) {
  .hide-on-drawer-visible {
    display: none !important;
  }

  .drawer {
    -webkit-box-flex: 0;
        -ms-flex: 0 0 280px;
            flex: 0 0 280px;
  }
  .drawer .drawer-content {
    z-index: inherit;
    left: 0;
    right: 0;
    position: absolute !important;
    left: 0 !important;
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
  }

  .drawer .drawer-backdrop {
    display: none;
  }
  .drawer-content {
    position: absolute;
  }
}

@media screen and (max-width: 921px) {
  .drawer.active .drawer-backdrop {
    display: block;
  }
}*/

.drawer-header {
  overflow: hidden;
  position: relative;
  margin-bottom: 8px;
  padding: 16px;
  font-size: 0.9rem;
}

.drawer-header > img {
  position: absolute;
  top: 0;
  bottom: 0;
  left: -50%;
  width: 100%;
  height: 100%;
  -webkit-left: 50%);
          left: 50%);
  z-index: -1;
}

.drawer-header > div {
  color: #fff;
}

.drawer-header .avatar img {
  height: 64px;
  width: 64px;
  margin-bottom: 25px;
  border-radius: 50%;
}

.drawer .list {
  margin: 0;
}

.drawer-content hr {
  margin: 0;
}
</style>
